import React from 'react'
import { Theme } from 'features/ui/types'
import styled from 'styled-components'
// @ts-ignore
import { sys } from '@netbasequid/theme'
import { useDisplayTheme } from 'hooks/useUiState'

const Divider = styled.hr`
  margin: 0;
  border-width: 0;
  border-bottom: 1px solid ${({ mode }: { mode: Theme }) => sys[mode].common.divider[100]};
`

const ThemedDivider = () => {
  const theme = useDisplayTheme() as Theme
  return <Divider mode={theme} />
}

export default ThemedDivider
